import { Injectable } from '@angular/core';

import {ActivatedRoute, Resolve} from '@angular/router';
import {Observable} from 'rxjs';
import {ApiService, Software, SoftwaresList} from '../api/api.service';

@Injectable(
  {
    providedIn:'root'
  }
)
export class StoreResolver implements Resolve<Observable<SoftwaresList>> {

  constructor(private api: ApiService) {}


  resolve() {
    return this.api.getSoftwaresList();
  }
}
